import { Controller } from "stimulus";

export default class extends Controller {
  static values = { count: Number };

  connect() {
    const badge = document.querySelector(".js-notes-tab-badge");
    if (!badge) return;

    badge.classList.toggle("d-none", this.countValue === 0);

    const pill = badge.querySelector(".badge");
    if (pill) pill.textContent = this.countValue;
  }
}
